import React from 'react'
import styles from './PillGroup.scss'
import cx from 'classnames'

export class PillGroup extends React.PureComponent {
  toggleSelected = (k) => {
    const {selected, onChange} = this.props
    const newSelected = selected.has(k)
      ? selected.remove(k)
      : selected.add(k)

    onChange(newSelected)
  }

  render () {
    const {options, selected, style, inline} = this.props
    return (
      <div className={cx(styles.PillGroup, inline && styles.inline)} style={style}>
        {options.map((v, k) =>
          <GroupItem v={v} k={k} key={k} selected={selected.has(k)} onToggle={this.toggleSelected} />
        ).toIndexedSeq()}
      </div>
    )
  }
}

const GroupItem = ({v, k, selected, onToggle}) => (
  <div
    data-content={v}
    className={cx(styles.groupItem, selected && styles.selected)}
    onClick={() => { onToggle(k) }} >
    {v}
  </div>
)
